import { useMemo } from "react";

import { Link, Route, Routes, useLocation } from "react-router-dom";

import { Menu } from "simplydo/react/ui";

import { useAppSelector } from "store";
import util from "utils/utils";

import CalendarSettings from "components/calendars/CalendarManagement/EditCalendar/CalendarSettings";

import type { ChallengeDetail } from "../../types";
import Planner from "./Planner";

type PlannerMenuProps = { challenge: ChallengeDetail };

const PlannerMenu = ({ challenge }: PlannerMenuProps) => {
  const challengeId = challenge._id;
  const calendarId = challenge.calendar?._id;
  const user = useAppSelector((state) => state.user);
  const location = useLocation();

  const canManageChallenge = useMemo(
    () => util.canManageChallenge(user, challenge),
    [user, challenge],
  );
  const canEditPlanner = useMemo(
    () =>
      canManageChallenge ||
      (!!calendarId &&
        !!challengeId &&
        util.hasPermission(user, "calendar.edit", calendarId, challengeId)),
    [user, canManageChallenge, calendarId, challengeId],
  );

  return (
    <div>
      <Menu pointing secondary>
        <Menu.Item
          active={util.activePath("/planner$", location)}
          icon="calendar"
          content="Planner"
          as={Link}
          to="."
        />
        {canEditPlanner ?
          <Menu.Item
            active={util.activePath("/planner/settings", location)}
            icon="cogs"
            content="Settings"
            as={Link}
            to="settings"
          />
        : null}
      </Menu>

      <Routes>
        {canEditPlanner && challengeId && calendarId ?
          <Route
            path="settings"
            element={
              <CalendarSettings
                forType="challenge"
                forId={challengeId}
                calendarId={calendarId}
              />
            }
          />
        : null}
        <Route path="/" element={<Planner challenge={challenge} />} />
      </Routes>
    </div>
  );
};

export default PlannerMenu;
